import { render, staticRenderFns } from "./licenseList.vue?vue&type=template&id=683a2a86&scoped=true"
import script from "./licenseList.vue?vue&type=script&lang=js"
export * from "./licenseList.vue?vue&type=script&lang=js"
import style0 from "./licenseList.vue?vue&type=style&index=0&id=683a2a86&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683a2a86",
  null
  
)

export default component.exports